import React from 'react';
import { Modal } from 'antd';
import classnames from 'classnames';
import './index.less';
import loginHint from '@/assets/images/icons/login_hint.png';

interface AccountExistsProps {
  visible: boolean;
  visableTitle?: string;
  visableHint?: string | undefined;
  current: number;
  footerBtnChange: (value: string) => void;
}

function AccountExists(props: AccountExistsProps) {
  const footerBtn =
    props.current === 0 ? (
      <div className="accountExists_layout__footerBtn" key="login">
        <span onClick={() => props.footerBtnChange('visible')}>确定</span>
      </div>
    ) : props.current === 1 ? (
      <div className="accountExists_layout__footerBtn" key="register">
        <span onClick={() => props.footerBtnChange('login')}>去登录</span>
        <span onClick={() => props.footerBtnChange('visible')}>确定</span>
      </div>
    ) : (
      <div className="accountExists_layout__footerBtn" key="register">
        <span onClick={() => props.footerBtnChange('password')}>是</span>
        <span onClick={() => props.footerBtnChange('visible')}>否</span>
      </div>
    );
  return (
    <Modal
      visible={props.visible}
      width={270}
      footer={[footerBtn]}
      closable={false}
      getContainer={false}
      maskClosable={false}
      className={classnames('accountExists_layout', { accountExists_layout_max: props.current === 1 })}
    >
      <p className="accountExists_layout__title" style={{ paddingTop: props.current === 2 ? '46px' : '12px' }}>
        {props.visableTitle}
      </p>
      <p className="accountExists_layout__hint" style={{ textAlign: props.current !== 0 ? 'center' : 'left' }}>
        {props.visableHint}
      </p>
      {props.current === 1 ? (
        <div className="accountExists_layout__inner">
          <img src={loginHint} alt="" />
          <span>如果您在996引擎的游戏内注册过该账号可直接使用该账号登录盒子</span>
        </div>
      ) : (
        <></>
      )}
    </Modal>
  );
}

export default AccountExists;
